import React from 'react';

export const OITTexts = {
  title: {
      ko: (
        <>
          내부자 위협 관리 솔루션
        </>
      ),
      en: (
        <>
          Insider Threat Management Solution
        </>
      )
  },
  subtitle: {
      ko: (
        <>
          ObserveIT
        </>
      ),
      en: (
        <>
          ObserveIT
        </>
      )
  }
};

export const outlineTexts = {
  title: {
      ko: (
        <>
          ObserveIT 개요
        </>
      ),
      en: (
        <>
          ObserveIT Overview
        </>
      )
  },
  topic:
  {
    smalltitle: {
      ko: <>"의도적인 내부자 위협, 어떻게 막을까?"</>,
      en: <>"How to Prevent Intentional Insider Threats?"</>
    },
    title: {
      ko: '보안적 가시성 확보를 통한 안전한 업무 환경 보장',
      en: 'Ensuring a Safe Work Environment through Security Visibility'
    },
  },
  detection:
  {
    smalltitle: {
      ko: '파악하기 어려운',
      en: 'Difficult to Identify'
    },
    title: {
      ko: '내부자 위협 탐지',
      en: 'Insider Threat Detection'
    },
    desc: {
      ko: <>
        조직 내부의 잠재적 위험에 근본이 되는 특정 사용자의 행위 및 의도와 관련된 정황을 신속하게 파악
      </>,
      en: <>
        Quickly identify the context related to the actions and intentions of specific users that underpin potential risks within the organization.
      </>
    }
  },
  visibility:
  {
    smalltitle: {
      ko: '규정준수 & 원인규명',
      en: 'Compliance & Forensics'
    },
    title: {
      ko: '보안 가시성 확보',
      en: 'Security Visibility'
    },
    desc: {
      ko: <>
        정책 기반의 이상 행위를 실시간 탐지하여, 사고 대응에 필요한 직관적인 분석 정보 및 자동 대응 프로세스 제공
      </>,
      en: <>
        Provides real-time detection of anomalous behaviors based on policies, offering intuitive analysis information and automated response processes necessary for incident response.
      </>
    }
  },
  platform:
  {
    smalltitle: {
      ko: '서로 다른 업무 환경',
      en: 'Different Work Environments'
    },
    title: {
      ko: '다양한 플렛폼 지원',
      en: 'Platform Support'
    },
    desc: {
      ko: <>
        원격 사무 환경, 데스크탑, 서버, Mac, 스마트웨크 오피스 환경등 기업 정책에 최적화된 서비스 제공
      </>,
      en: <>
        Provides services optimized for corporate policies in remote work environments, desktops, servers, Mac, and smart work office environments.        
      </>
    }
  },
};

export const specialTexts = {
  title: {
      ko: (
        <>
          ObserveIT 특징
        </>
      ),
      en: (
        <>
          ObserveIT Features
        </>
      )
  },
  detectiontitle: {
      ko: (
        <>
          이상 행위 탐지
        </>
      ),
      en: (
        <>
          Anomaly Detection
        </>
      )
  },
  detectionmessage: {
      ko: (
        <>
          시스템의 부하를 최소화 하여 네트워크, 프로세스,메일 등 다양한 경로를 통해 
          발생하는 비정상적인 행위를 식별하여 내부자 위험 활동을 탐지합니다.
        </>
      ),
      en: (
        <>
          Identifies abnormal behaviors occurring through various channels such as
          network, processes, and email to detect insider threat activities.
        </>
      )
  },
  historytitle: {
      ko: (
        <>
          작업 이력 관리
        </>
      ),
      en: (
        <>
          Work History Management
        </>
      )
  },
  historymessage: {
      ko: (
        <>
          사용자의 모든 작업은 구조화된 메타데이터 및 영상 정보를 저장하여 관리합니다. 
          영상 정보는 30KB 사이즈로 높은 효율의 압축율을 보장합니다.
          </>
      ),
      en: (
        <>
          All user activities are managed by storing structured metadata and video information.
          The video information is compressed to ensure the most efficient size of around 30KB.
        </>
      )
  },
  audittitle: {
      ko: (
        <>
          감사 증적
        </>
      ),
      en: (
        <>
          Audit Evidence
        </>
      )
  },
  auditmessage: {
      ko: (
        <>
        사용자의 비정상적인 행위 및 의심스러운 활동을 과거 부터 현재까지 녹화를 관리하여 
        사용자 행동을 확인 하며 증적으로 삼을 수 있습니다. 
          </>
      ),
      en: (
        <>
          Manages the recording of abnormal and suspicious user activities from the past to the present,
          allowing for verification of user behavior and serving as evidence.
        </>
      )
  },
  processtitle: {
      ko: (
        <>
          대응 프로세스
        </>
      ),
      en: (
        <>
          Response Process
        </>
      )
  },
  processmessage: {
      ko: (
        <>
          비정상적인 행위에 대해 경고, 프로세스 차단, 소명 절차등를 자동으로
          대응할 수 있는 프로세스를 제공합니다.
          </>
      ),
      en: (
        <>
          Provides automated response processes for abnormal behaviors, including alerts, process blocking, 
          and appeal procedures.
        </>
      )
  }
};

export const functionTexts = {
  title: {
      ko: (
        <>
          ObserveIT 주요기능
        </>
      ),
      en: (
        <>
          ObserveIT Key Features
        </>
      )
  },
  monitoring:
    {
      title: {
        ko: '사용자 행동 모니터링',
        en: 'User Activity Monitoring'
      },
      desc: {
        ko: <>
              ○ 회사의 중요한 데이터를 쉽게 유출할 수 있는 메일에 대한 모니터링
              <br />○ 클라이언트의 Web 또는 메일에서 전송되거나 첨부된 파일 모니터링
              <br />○ 고위험 사용자 정보를 제공하며 각 활동에 대한 지난 30일 동안의 세부 행동이 얼마나 위험한지에 대해 활동의 시각화 정보 제공
        </>,
        en: <>
              ○ Monitoring of emails that can easily leak critical company data.
              <br />○ Monitoring files sent or attached via client web or email.
              <br />○ Provides high-risk user information and visualizes how risky each activity has been over the past 30 days.
        </>
      }
    },
  detection:
    {
      title: {
        ko: '이상행위 탐지 및 경고',
        en: 'Anomaly Detection & Alert'
      },
      desc: {
        ko: <>
              ○ 이상행위 대응 프로세스를 통해 행위에 대한 경고 알림 기능
              <br />○ 소명 프로세스로 행위자에게 편의성을 제공하며, 관리자에게는 영상정보 및 프로그램 강제 종료를 통한 체계적 대응 환경 제공
              <br />○ 전문화된 카테고리 분류로 오탐 최소화 및 검색 효율성 극대화
              <br />○ 경고 정책의 유연함과 확장성은 높은 보안성과 가시성 보장
        </>,
        en: <>
              ○ Provides alert notification functionality through anomaly response processes.
              <br />○ Offers convenience to actors through an appeal process, while providing a systematic response environment to administrators through video information and forced program termination.
              <br />○ Minimizes false positives and maximizes search efficiency through specialized category classification.
              <br />○ Flexible and extensible detection policies provide high security and visibility.
        </>
      }
    },
  recording: {
      title: {
        ko: '세션 녹화 및 재생',
        en: 'Session Recording & Playback'
      },
      desc: {
        ko: <>
              ○ 작업 이력을 영상으로 제공하여, 직관적인 보안의 가시성 제공
              <br />○ 스냅샷 방식의 이미지는 평균 30KB사이즈로 효율성 극대화
              <br />○ 영상 정보는 별도 저장이 가능하며, 재생 시 관리 암호 입력 단계를 통해 관리자 오남용 방지
              <br />○ 마스킹 처리는 특정 행위 기록 정책에 따라 녹화 생성/보관 시 개인 정보 노출 최소화
        </>,
        en: <>
              ○ Provides work history in video format, ensuring intuitive security visibility.
              <br />○ Snapshot images are around 30KB in size, maximizing efficiency.
              <br />○ Video information can be stored separately, and an admin password input step during playback prevents misuse by administrators.
              <br />○ Masking minimizes personal information exposure during recording/retention based on specific activity recording policies.
        </>
      }
    },
  policy:{
      title: {
        ko: '실시간 정책 및 차단',
        en: 'Real-time Policy Enforcement & Blocking'
      },
      desc: {
        ko: <>
              ○ 보안 관리자는 별도의 정책을 구성할 필요없이 기본적으로 제공되는 기록 정책 템플릿 제공.
              <br />○ 특정 그룹/사용자/응용프로그램/URL 등에 대해 별도의 기록 정책 생성 또는 예외 처리.
              <br />○ 각각의 OS 특성에 최적화된 정책 템플릿 제공.
              <br />○ 다양한 조건식과 경고 정책의 세밀함은 사용자 및 관리자의 편의성 보장.
        </>,
        en: <>
              ○ Security administrators can use pre-configured recording policy templates without needing to create separate policies.
              <br />○ Create or exempt recording policies for specific groups/users/applications/URLs.
              <br />○ Provide optimized recording policy templates for each OS.
              <br />○ The flexibility and scalability of alert policies ensure high security and visibility.
              <br />○ The variety of conditional expressions and the detail of alert policies ensure convenience for users and administrators.
        </>
      }
    },
  audit:{
      title: {
        ko: '감사 및 보고서',
        en: 'Audit & Reporting'
      },
      desc: {
        ko: <>
              ○ 각각의 이상행위에 대해 위험도를 책정하여 사용자의 위험지수 통계 및 시각화
              <br />○ 웹에서 다운로드 된 파일의 투명한 정보 흐름 관리 (파일 추적)
              <br />○ 클라우드(OneDrive, Google Drive 등)에서 작업되는 파일의 라이프 사이클 관리
              <br />○ USB 장치로 복사 또는 다운로드한 파일을 추적하고 모니터링 장치(인가/비인가) 선택
        </>,
        en: <>
              ○ Tracks and monitors files copied or downloaded to USB devices, allowing for the selection of monitoring devices (authorized/unauthorized).
              <br />○ Tracks and monitors files copied or downloaded from cloud services (OneDrive, Google Drive, etc.).
              <br />○ Tracks and monitors files copied or downloaded from USB devices, allowing for the selection of monitoring devices (authorized/un
        </>
      }
    },
  dashboard:{
      title: {
        ko: '위험지수 기반 대시보드',
        en: 'Risk-based Dashboard'
      },
      desc: {
        ko: <>
              ○ 이상 행위는 위험도 별 스코어링 되어 위험지수 통계 및 시각화
              <br />○ 위험지수 Top N 정보를 통한 조직의 보안 대응 프로세스 정립
        </>,
        en: <>
              ○ Anomalies are scored based on risk levels, providing risk index statistics and visualization.
              <br />○ Establishing security response processes for the organization through risk index Top N information.
        </>
      }
    },

}

export const certTexts = {
  title: {
      ko: (
        <>
          인증
        </>
      ),
      en: (
        <>
          Certifications
        </>
      )
  }
};
